import PatientList from '../../components/patient/PatientList';

export default function PatientsListPage() {
  return <PatientList />;
}
